module.exports = __webpack_public_path__ + "public/files/img/history.574b216d.png";